import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FollowUpTab } from 'src/app/modules/shared/entities/follow-up-tab.enum';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { AccountManager } from 'src/app/modules/shared/entities/account-manager.class';
import { NotificationService } from 'core/notification/notification.service';
import { NotificationType } from 'core/notification/notification-config.class';
import { DashboardService } from '../services/dashboard.service';
import { LeadsTableComponent } from './leads-table/leads-table.component';
import { ProjectsTableComponent } from './projects-table/projects-table.component';

@Component({
  selector: 'app-follow-up',
  templateUrl: './follow-up.component.html',
  styleUrls: ['./follow-up.component.scss'],
  standalone: false
})
export class FollowUpComponent implements OnInit {
  @Input() accountManagerEmployeeId: string;
  appStrings: AppLocalization;
  amEmployeeId: string;
  loading = false;
  isAccountManager = false;
  accountManagerId: string;
  mobileToggleValues: any;
  tabs = FollowUpTab;
  activeTab = this.tabs.Leads;

  @ViewChild('leads') leadsTable: LeadsTableComponent;
  @ViewChild('leadsHistory') leadsHistoryTable: LeadsTableComponent;
  @ViewChild('projects') projectsTable: ProjectsTableComponent;
  @ViewChild('projectsHistory') projectsHistoryTable: ProjectsTableComponent;
  @ViewChild('fileUploadControl') fileUploadControl: ElementRef;

  constructor(
    private appInfoService: AppInfoService,
    private dashboardService: DashboardService,
    private notificationService: NotificationService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.amEmployeeId = this.appInfoService.userData.UserInfo.EmployeeId;
    this.setupMobileToggleButtons();

    this.isAccountManager = this.appInfoService.isAccountManager();
    this.dashboardService.getAccountManagers((list: AccountManager[]) => {
      list.forEach((item: AccountManager) => {
        if (item.employeeId === this.amEmployeeId) {
          this.accountManagerId = item.id;
        }
      });
    });
  }

  onTabChange(index: number) {
    this.activeTab = index;
  }

  onTabChangeMobile(selectedTab: any) {
    this.activeTab = FollowUpTab[selectedTab.value.split(' ').join('') as keyof typeof FollowUpTab];
  }

  handleAddNew() {
    this.router.navigate(['/leads/leads-management/new']);
  }

  handleUploadExcel() {
    this.fileUploadControl.nativeElement.click();
  }

  uploadExcel(event: any) {
    const files: FileList = event.target.files;
    const target = event.target;
    this.loading = true;
    if (files.length > 0) {
      this.dashboardService.uploadExcel(files, error => this.afterUpload(error, target));
    } else {
      this.afterUpload({}, target);
    }
  }

  afterUpload(error: any, target: any) {
    if (target) {
      target.value = null; // reset excel file input
    }
    if (!error) {
      this.loading = false;
      this.leadsTable.getLeads(true, true);
      this.notificationService.showNotification(
        this.appStrings.leads_importNotification,
        NotificationType.Success,
        false,
        true
      );
    }
    this.loading = false;
  }

  handleDownloadExcel() {
    this.dashboardService.downloadExcelTemplate();
  }

  searchLeads() {
    this.leadsTable?.getLeads(false, true);
  }

  searchLeadsHistory() {
    this.leadsHistoryTable?.getLeads(false, true);
  }

  searchProjects() {
    this.projectsTable?.getProjects(false, true);
  }

  searchProjectsHistory() {
    this.projectsHistoryTable?.getProjects(false, true);
  }

  addNewProject() {
    this.projectsTable.openEditProject();
  }

  private setupMobileToggleButtons() {
    this.mobileToggleValues = [{
      value: this.appStrings.followUp_leads_title
    }, {
      value: this.appStrings.followUp_leadsHistory_title
    }, {
      value: this.appStrings.followUp_projects_title
    }, {
      value: this.appStrings.followUp_projects_historyTitle
    }];
  }
}
